import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppStateService } from '../../services/app-state.service';
import { Subscription } from 'rxjs';
import { PageButtonComponent } from '../buttons/page-button.component';
import { CommonModule } from '@angular/common';
import {CircleButtonComponent} from '../buttons/circle-button.component';
import {TranslateService} from '../../services/translate.service';

@Component({
  selector: 'app-sign-out',
  standalone: true,
  imports: [
    PageButtonComponent,
    CommonModule,
    CircleButtonComponent
  ],
  templateUrl: './sign-out.component.html',
  styleUrls: ['./sign-out.component.css']
})
export class SignOutComponent implements OnInit {
  isLoading = true;
  private stateSub: Subscription | undefined;
  private venueId: Number | null = null;

  constructor(
    private router: Router,
    private appState: AppStateService,
    public translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.stateSub = this.appState.observeAppState().subscribe(app => {
      this.venueId = app.venueId;
      if (app.order.user_cfg.is_anon) {
        this.isLoading = false;
      } else {
        console.log('SignOutComponent: User is not anonymous, redirecting to menu');
        this.router.navigateByUrl(`${app.venueId}/menu/food`);
      }
    });
  }

  goToStartPage() {
    this.router.navigateByUrl(`${this.venueId}/start`);
  }

  ngOnDestroy() {
    this.stateSub?.unsubscribe();
  }
}
